export enum AuditTrailChangedProperty {
    PROJECT = 'project',
    EMPLOYEE = 'employee',
    FROM = 'from',
    TO = 'to',
    DURATION = 'duration'
}
